import e from "react";
import { documentToReactComponents as r } from "@contentful/rich-text-react-renderer";
const c = e.memo(
  ({ content: t, options: o }) => /* @__PURE__ */ e.createElement(e.Fragment, null, r(t, o))
);
export {
  c as RichTextRenderer
};
